import cn from 'classnames';
import { Menu } from 'primereact/menu';
import { MenuItem } from 'primereact/menuitem';
import { MouseEvent, MutableRefObject } from 'react';

import styles from './ExportMenuItem.module.scss';

interface ExportMenuItemProps {
  item: MenuItem;
  handleOnClick: () => void;
  menuReference: MutableRefObject<null | Menu>;
  icon: string;
}

export default function ExportMenuItem({ item, handleOnClick, menuReference, icon }: ExportMenuItemProps) {
  const hideMenu = (event: MouseEvent) => {
    menuReference.current?.toggle(event);
  };

  const handleOnItemClick = (event: MouseEvent) => {
    handleOnClick();
    hideMenu(event);
  };

  return (
    <a
      href='#'
      className={cn('p-menuitem-link', styles.menuItem)}
      onClick={(event) => handleOnItemClick(event)}
      role='menuitem'
      tabIndex={0}
      data-testid={`${item.label}-menu-item`}
    >
      <span className={cn(`p-menuitem-icon pi ${icon}`, styles.icon)} />
      <span className={cn('p-menuitem-text', styles.text)}>{item.label}</span>
    </a>
  );
}
